import * as React from 'react'
import {ReactElement} from 'react'
import styled from 'styled-components'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import { Table, TableRow, TableBody, TableCell, Box } from '@mui/material';
import {Colors} from '../../../../styledComponents/Constants'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'

interface Props {
    cardKeyNumber: string
    eventEmitter: EventEmitterExAdmin
    onChange: (value: string) => void
}

interface State {
    cardKeyNumber: string
}

export default class NatRegistrationApplyCardKeyNumberForm extends React.Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            cardKeyNumber: this.props.cardKeyNumber,
        }
        this.handleCardKeyNumberChange = this.handleCardKeyNumberChange.bind(this)
    }

    handleCardKeyNumberChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            cardKeyNumber: event.target.value,
            }, () => {
                this.props.onChange(this.state.cardKeyNumber)
            }
        )
    }

    render(): ReactElement {
        return (
            <FormBox>
                <Table>
                    <TableBody>
                        <TableRow>
                            <RowNameCell>カードキー番号</RowNameCell>
                            <InputCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 10,
                                            placeholder: 'カードキー番号',
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.cardKeyNumber}
                                    eventKeys={['cardKeyNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleCardKeyNumberChange}
                                />
                            </InputCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormBox>
        )
    }
}

const FormBox = styled(Box)`
  border: solid 2px ${Colors.Shadow};
  margin: 5px;
  padding: 10px;
`
const RowNameCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  font-size: 1rem;
  line-height: 2.3em;
  vertical-align: top;
  white-space: nowrap;
  padding: 2px 12px 2px 12px;
  }
`
const InputCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  white-space: nowrap;
  width: 100%;
  }
`